import {
  HttpEvent,
  HttpInterceptorFn,
  HttpResponse
} from '@angular/common/http';
import { tap, from, switchMap } from 'rxjs';
import { inject } from '@angular/core';
import { AccountService } from "../services/account/account.service";
import { GoogleAnalyticsService } from '../services/helpers/gtag.service';

export const httpInterceptor: HttpInterceptorFn = (req, next) => {
  const account = inject(AccountService);
  const ga = inject(GoogleAnalyticsService);

  if (req.method === 'POST' && req.body && typeof req.body === 'object' && !(req.body instanceof FormData)) {

    return from(ga.getClientId()).pipe(
      switchMap((clientId) => {

        const body = req.body as Record<string, any>;

        const modifiedReq = req.clone({
          body: {
            ...body,
            gtag_id: clientId
          }
        });

        return next(modifiedReq).pipe(
          tap((event: HttpEvent<any>) => {
            if (event instanceof HttpResponse) {
              const response = event.body;
              if (response && !response.success && response.result) {
                if (response.result.code === 20401) {
                  account.logout('session').then(() => { });
                }
              }
            }
          })
        );
      })
    );
  }

  return next(req).pipe(
    tap((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        const response = event.body;
        if (response && !response.success && response.result) {
          if (response.result.code === 20401) {
            account.logout('session').then(() => { });
          }
        }
      }
    })
  );
};